import { useUser } from "@/contexts/User"
import { forwardRef, useContext, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router"
import NavbarItem from "./NavbarItem"
import { DimensionContext } from "@/contexts/Dimension"

const Tabs = [
  {
    img: "/assets/images/navbar/earn.svg",
    link: "/quests",
    title: "quests",
    name: "quests",
  },
  {
    img: "/assets/images/navbar/customs.svg",
    link: "/customs",
    title: "customs",
    name: "customs",
  },
  {
    img: "/assets/images/navbar/home.svg",
    link: "/",
    title: "home",
    name: "",
  },
  {
    img: "/assets/images/navbar/friends.svg",
    link: "/friends",
    title: "friends",
    name: "friends",
  },
  {
    img: "/assets/images/navbar/profile.svg",
    link: "/profile",
    title: "profile",
    name: "profile",
  },
]

const Navbar = forwardRef<HTMLDivElement>((_, ref) => {
  const { t } = useTranslation("Navbar")
  const { userTasks } = useUser()
  const { isDark, safeArea } = useContext(DimensionContext)
  const location = useLocation()

  const tasksIncomplete = useMemo(() => {
    return userTasks?.some(
      (task) => task.tasksXUser?.[0]?.status !== "COMPLETED"
    )
  }, [userTasks])

  return (
    <>
      <div
        ref={ref}
        className="animate-fade-in border-hint-color-20 bg-section dark:bg-dark-section fixed bottom-0 left-0 z-[30] flex w-full rounded-tl-3xl rounded-tr-3xl border-t px-3 pt-2.5"
        style={{ paddingBottom: safeArea.bottomSafeArea }}
      >
        {Tabs.map((tab, i) => (
          <NavbarItem
            key={`tab-${i}`}
            name={tab.name}
            title={t(tab.title)}
            img={tab.img}
            link={tab.link}
            tasksIncomplete={tasksIncomplete}
            picked={location.pathname === `/${tab.name}`}
            isDark={isDark}
          />
        ))}
      </div>
    </>
  )
})

export default Navbar
